import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../api/api";
import ProductsOrderTable from "../../components/Tables/ProductsOrderTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IProduct, IProductsOrderUpdDto } from "../../types/product.type";
import styles from "./styles.module.scss";

const ProductsOrderPage: React.FC = () => {
  const [products, setProducts] = useState<IProduct[]>([]);

  const getProducts = async () => {
    try {
      const results = await authApiService.getAllProductsForOrder();
      return results;
    } catch (err: any) {
      console.error(err);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    (async () => {
      const data = await getProducts();
      if (data) {
        setProducts(data);
      }
    })();
  }, []);

  const updateOrder = async (ids: string[]) => {
    try {
      const body: IProductsOrderUpdDto = {
        ids,
      };
      await authApiService.updateProductsOrder(body);
    } catch (err: any) {
      toast.error(err.response.data.message);
      console.error(err);
    }
  };

  const moveItem = (index: number, direction: "up" | "down") => {
    const newRecomendations = [...products];
    const swapIndex = direction === "up" ? index - 1 : index + 1;

    if (swapIndex >= 0 && swapIndex < products.length) {
      [newRecomendations[index], newRecomendations[swapIndex]] = [
        newRecomendations[swapIndex],
        newRecomendations[index],
      ];
      setProducts(newRecomendations);
      updateOrder(newRecomendations.map((item) => item.id));
    }
  };

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={products?.length || 0} />
      </div>

      <ProductsOrderTable products={products} onClickRow={moveItem} />
    </main>
  );
};

export default ProductsOrderPage;
